import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import { CollaborationNetworkApi } from '../../../api/collaboration-network/collaboration-network.api';
import { MediaApi } from '../../../api/media-file/MediaFile.api';
import { RootState } from '../../../store/store';
import { checkPermission } from '../../../utils/app.utils';

const ManageState = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_COLLABORATION_NETWORK', permission);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [id_collaboration_network, set_id_collaboration_network] = useState<number | null>(null);
    const [status, set_status] = useState<string>("");

    const [showModal, setShowModal] = useState<string>("");
    const [id_media_file, set_id_media_file] = useState<any>()
    const [showModalMedia, setShowModalMedia] = useState<boolean>(false);

    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [form, set_form] = useState<any>({
        collaboration_network_name: ""
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_id_collaboration_network(null);
        set_form({ collaboration_network_name: "" })
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_collaboration_network", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("ชื่อเครือข่ายความร่วมมือ")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            collaboration_network_name,
            created_by,
            created_date,
            modified_date,
            modified_by,
            id_collaboration_network

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: collaboration_network_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit={checkPermit.isUpdate}
                            enableView={checkPermit.isView}
                            enableDelete={checkPermit.isDelete}
                            onViewClick={() => handleGetOneDetail(id_collaboration_network, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_collaboration_network, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_collaboration_network)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    // const handleChangeStatus = async (id_collaboration_network: number, st: boolean) => {
    //     const body: updateStatusType = {
    //         status: st ? COMPLAINT_TYPE_STATUS.INACTIVE : COMPLAINT_TYPE_STATUS.ACTIVE
    //     }
    //     dispatch(setLoading());
    //     await CollaborationNetworkApi.updateStatus(id_collaboration_network, body).then((res) => {
    //         if (res.status < 300) {
    //             handleGetData();
    //         }
    //     }).catch((err) => {
    //         alertError(t("COMPLAINTS_UPDATE_STATUS"), t("COMPLAINTS_UPDATE_STATUS_FAILED"))
    //         console.log(err)
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }
    const handleDeleteList = (id_collaboration_network: number) => {
        alertActive(t("ลบเครือข่ายความร่วมมือ"), t("ต้องการลบเครือข่ายความร่วมมือ หรือไม่?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await CollaborationNetworkApi.deleteCollaborationNetwork(id_collaboration_network).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบเครือข่ายความร่วมมือ"), t("ลบเครือข่ายความร่วมมือ เรียบร้อยแล้ว"))

                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบเครือข่ายความร่วมมือ"), t("ลบเครือข่ายความร่วมมือ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await CollaborationNetworkApi.getAllCollaborationNetwork(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])


    const handleGetOneDetail = async (id_collaboration_network: number, mode: string) => {
        setShowModal(mode);
        set_id_collaboration_network(id_collaboration_network)
        dispatch(setLoading());
        await CollaborationNetworkApi.getCollaborationNetworkById(id_collaboration_network).then((res) => {
            if (res.status < 300) {
                set_form(res.data?.data)
                GetFile(res.data?.data?.id_media_file)
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleSubmitForm = async () => {
        dispatch(setLoading());
        const body = {
            collaboration_network_seq: form?.collaboration_network_seq,
            collaboration_network_name: form?.collaboration_network_name,
            collaboration_network_link: form?.collaboration_network_link,
            id_media_file: id_media_file
        }
        if (id_collaboration_network) {

            await CollaborationNetworkApi.updateCollaborationNetwork(id_collaboration_network, body).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("แก้ไขเครือข่ายความร่วมมือ"), t('แก้ไขเครือข่ายความร่วมมือ เรียบร้อยแล้ว'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err.response.data.message)
                alertError(err.response.data.message || t("แก้ไขเครือข่ายความร่วมมือ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await CollaborationNetworkApi.createCollaborationNetwork(body).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("เพิ่มเครือข่ายความร่วมมือ"), t("เพิ่มเครือข่ายความร่วมมือ เรียบร้อยแล้ว"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(err.response.data.message || t("เพิ่มเครือข่ายความร่วมมือ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [handleGetData])
    const [media_file_path, set_media_file_path] = useState<any>('')

    const GetFile = async (id: any) => {
        await MediaApi.findOneFile(id).then((res) => {
            if (res.status < 300) {
                console.log(res.data.data);
                set_media_file_path(`${res.data.data?.media_file_path}${res.data.data?.media_file_name}`)

            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
        })
    }

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        id_collaboration_network,
        set_id_collaboration_network,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        id_media_file,
        set_id_media_file,
        showModalMedia,
        setShowModalMedia,
        media_file_path,
        set_media_file_path,
        GetFile,
        checkPermit
    }
}

export default ManageState
